import type { SessionCommentAttributes, UserAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'
import SessionQ from './SessionQ'
import UserQ from './UserQ'

const SessionCommentQ = {
  ...makeQueryModelV2<SessionCommentAttributes>('session_comment')([
    'id',
    'session_id',
    'user_id',
    'message',
    'message_safe',
    'hidden_at',
    'created_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    User: {
      query: UserQ,
      foreignKey: UserQ.id,
      sourceKey: SessionCommentQ.user_id,
    },
    Session: {
      query: SessionQ,
      foreignKey: SessionQ.id,
      sourceKey: SessionCommentQ.session_id,
    },
  }),

  where: (
    {
      paranoid = true,
      sessionId,
      userId,
      include = [],
      groupBy = null,
      order = null,
    }: {
      paranoid?: boolean
      sessionId?: number | null | SQLFragment<number>
      userId?: number | null | SQLFragment<number>
      include?: IncludeAssociations
      groupBy?: GroupBy | null
      order?: QueryOrder | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<SessionCommentAttributes> => SQL`
        FROM ${SessionCommentQ}
        ${includeAssociationsToSql(SessionCommentQ, include)}
        WHERE
            ${paranoid ? SQL`${SessionCommentQ.deleted_at} IS NULL AND` : SQL``}
            ${sessionId != null ? SQL`${SessionCommentQ.session_id} = ${sessionId} AND` : SQL``}
            ${userId != null ? SQL`${SessionCommentQ.user_id} = ${userId} AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
    `,

  getAuthor: (): SQLFragment<UserAttributes> =>
    SQL`${UserQ.where({
      id: SessionCommentQ.user_id,
    })}`,
}

export default SessionCommentQ
